import React, { useState } from 'react';
import { useGetCompanyQuery } from '../../store/Api';
import CompanyDetailsModal from './CompanyDetailsModal';

interface ICompanyNameDisplayProps {
    companyId?: string;
}

const CompanyNameDisplay: React.FC<ICompanyNameDisplayProps> = ({ companyId }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const company = useGetCompanyQuery(companyId ?? '', { skip: !companyId || companyId === '' });

    if (!companyId) return <span>-</span>;

    return (
        <>
            <span
                onClick={(e) => { e.stopPropagation(); setModalOpen(true); }}
                style={{ cursor: 'pointer', color: '#0078d4', textDecoration: 'underline' }}
                title="View company details"
            >
                {company.data?.companyName ?? 'Unknown Company'}
            </span>
            <CompanyDetailsModal
                company={companyId}
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
            />
        </>
    );
};

export default CompanyNameDisplay;
